import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MktglayoutComponent } from './_layout/mktglayout.component';
import { BudgetentryComponent } from './budgetentry/budgetentry.component';
import { PopmktgComponent } from './popmktg/popmktg.component';
import { ExcelUploadComponent } from './excel-upload/excel-upload.component';
import { AuthGuard } from './AuthGuard/auth.guard';
import { LoginComponent } from './login/login.component';
import { FoCostCenterComponent } from './fo-cost-center/fo-cost-center.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { Mktgp001Component } from './reports/mktgp001/mktgp001.component';
import { Mktgp006Component } from './reports/mktgp006/mktgp006.component';
import { Mktgp004Component } from './reports/mktgp004/mktgp004.component';
import { Mktgp002Component } from './reports/mktgp002/mktgp002.component';
import { Mktgp003Component } from './reports/mktgp003/mktgp003.component';
import { Mktgp005Component } from './reports/mktgp005/mktgp005.component';


const routes: Routes = [
  { path: '', component: LoginComponent, pathMatch: 'full' },
  {
    path: 'Mktg', component: MktglayoutComponent,
    children: [
      { path: 'Dashboard', component: DashboardComponent, canActivate: [AuthGuard] },
      { path: 'BudgetEntry', component: BudgetentryComponent, canActivate: [AuthGuard] },
      { path: 'PopMktg', component: PopmktgComponent, canActivate: [AuthGuard] },
      { path: 'Excelupload', component: ExcelUploadComponent, canActivate: [AuthGuard] },
      { path: 'FoCostCenter', component: FoCostCenterComponent, canActivate: [AuthGuard] },
    ]
  },
  {
    path: 'Report', component: MktglayoutComponent,
    children: [
      { path: 'MKTGP001', component: Mktgp001Component, canActivate: [AuthGuard] },
      { path: 'MKTGP006', component: Mktgp006Component, canActivate: [AuthGuard] },
      { path: 'MKTGP004', component: Mktgp004Component, canActivate: [AuthGuard] },
      { path: 'MKTGP002', component: Mktgp002Component, canActivate: [AuthGuard] },
      { path: 'MKTGP003', component: Mktgp003Component, canActivate: [AuthGuard] },
      { path: 'MKTGP005', component: Mktgp005Component, canActivate: [AuthGuard] }

    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
